import { render, staticRenderFns } from "./person-item.vue?vue&type=template&id=0adf458d&"
import script from "./person-item.vue?vue&type=script&lang=js&"
export * from "./person-item.vue?vue&type=script&lang=js&"
import style0 from "./person-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports